import { of } from 'rxjs'
import { ViewableIssue } from 'src/app/account/components/issues-view/issues-view.component'
import { AcmCertificateNotFoundIssue, KeyPairNotFoundIssue, RaisedIssueScope } from 'src/app/account/services/issue'
import { ResourceType } from 'src/utils/resource-types'
import { Arn } from 'src/utils/types'
import { resetIssueCounter, vi } from './showcase-issue-mock-utils'

// ARP-7238 scenario 1 — duplicate resource rows. The same resource (identical
// ARN) is raised three times for one problem. KeyPairNotFound groups all
// instances into a single content sub-group, so the three land together. The
// backend appends issues without deduping, so pre-fix this rendered three
// identical rows; dedupeIssues keeps the oldest of them.
export function buildDuplicateRowsScenario(): ViewableIssue[] {
  resetIssueCounter()
  const issues: ViewableIssue[] = []
  const dupArn = 'arn:aws:ec2:us-east-1:123456789012:instance/i-0duplicateinstance' as Arn
  for (let i = 0; i < 3; i++) {
    issues.push({
      ...vi(
        new KeyPairNotFoundIssue('shared-prod-keypair'),
        ResourceType.ec2Instance,
        RaisedIssueScope.BACKUP,
        'i-0duplicateinstance',
        dupArn
      ),
      // Stagger timestamps so the dedup "keep most recent" path is exercised.
      timestamp: new Date(Date.now() - i * 60_000),
    } as ViewableIssue)
  }
  return issues
}

// ARP-7238 scenario 2 — identical names break the diff-highlight. Two distinct
// resources (different ARNs) share one display name. Same content sub-group +
// same resource type drives the diff-highlight, whose common prefix/suffix
// overlap on identical names, so pre-fix the name rendered concatenated/tripled.
// Different ARNs mean dedup leaves both rows, so the highlight clamp is what
// keeps each name rendering once.
export function buildTripledNameScenario(): ViewableIssue[] {
  resetIssueCounter()
  const issues: ViewableIssue[] = []
  const sharedCertName = 'shared.example.com'
  for (const id of ['aaaa1111', 'bbbb2222']) {
    issues.push(
      vi(
        new AcmCertificateNotFoundIssue(
          `A certificate for '${sharedCertName}' could not be found in the recovery environment.`,
          `arn:aws:acm:us-east-1:123456789012:certificate/${id}`,
          sharedCertName
        ),
        ResourceType.acmCertificate,
        RaisedIssueScope.RESTORE,
        sharedCertName,
        `arn:aws:acm:us-east-1:123456789012:certificate/${id}`
      )
    )
  }
  return issues
}
